import Avatar from "components/common/Avatar";
import CardDropdown from "components/common/CardDropdown";
import Flex from "components/common/Flex";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";

import React, { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import { GetPageByName, PostPage, UploadFile } from "api/endpoints";

import { FloatingLabel, } from "react-bootstrap";
import { formatDateTimetoDateStr } from "api/constants";
import IconButton from "components/common/IconButton";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import { FiUpload } from "react-icons/fi";
import MEILoader from "components/ckeditor/MEILoader";
import FilePreviewer from "components/ckeditor/MEIFilePreview";





const schema = yup
    .object({
        pTitle: yup.string(),
        fFile: yup.string(),
        fDescription: yup.string(),
        metaDescription: yup.string(),
        metaTags: yup.string(),
        url: yup.string(),
        pName: yup.string(),
        pID: yup.string(),

    })
    .required();

const initialForm = {
    pTitle: '',
    fFile: '',
    fDescription: '',
    metaDescription: '',
    metaTags: '',
    url: '',
    pName: '',
    pID: '',

};


const SettingsForm = ({ setLoading }) => {


    const {
        register,
        formState: { errors },
        getValues,
        setValue,
        watch
    } = useFormContext();


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {

            const allowedTypes = [
                'image/jpeg', // .jpg, .jpeg
                'image/gif',  // .gif
                'image/png',  // .png
                'video/mp4' // .mp4
            ];
            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid File Format', {
                    theme: "colored",
                });
                e.target.value = '';
                return
            }
            else {
                const formData = new FormData();
                formData.append('file', file);
                setLoading(true)

                UploadFile(formData).then(res => {
                    // toast.success('File Uploaded Successfully!', {
                    //   theme: "colored",
                    // });
                    setValue('fFile', res?.data)
                    e.target.value = '';
                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                    toast.error('File Uploading Failed', {
                        theme: "colored",
                    });
                });
            }

        }
    };


    return (
        <>

            <Row className="gx-2 gy-3 pt-2">

                <Col md="12">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label='Page Title'
                            className=""
                        >
                            <Form.Control
                                type="text"
                                placeholder=""
                                isInvalid={!!errors.pTitle}
                                {...register("pTitle")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.pTitle?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>


                <Col md="12" style={{ position: 'relative' }}>
                    
                    <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
                        Header Media (1920 x 300)
                    </Form.Label>
                    <FilePreviewer accept=".jpg, .jpeg, .gif, .png, .mp4" furl={watch('fFile')} />


                    <Form.Label htmlFor={`file-upload-dp`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
                        <FiUpload className="me-1" size={40} />
                    </Form.Label>
                    <Form.Control
                        id={`file-upload-dp`}
                        type="file"
                        style={{ width: '120px' }}
                        onChange={(e) => handleFileChange(e)}
                        className="d-none"
                        accept=".jpg, .jpeg, .gif, .png, .mp4"
                    />

                </Col>



                <Col md="12">
                    <Form.Label>Page Content</Form.Label>
                    <MEICKEditor
                        value={getValues('fDescription')}
                        onchangeValue={(vl) => {
                            setValue('fDescription', vl)
                        }} />

                </Col>


                <Col md="6">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="Meta Description"
                            className=""
                        >
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder=""
                                isInvalid={!!errors.metaDescription}

                                style={{ height: '120px' }}
                                {...register("metaDescription")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.metaDescription?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>

                <Col md="6">
                    <Form.Group>
                        <FloatingLabel
                            controlId="floatingInput"
                            label="Meta Tags"
                            className=""
                        >
                            <Form.Control
                                as="textarea"
                                rows={4}
                                placeholder=""
                                isInvalid={!!errors.metaTags}

                                style={{ height: '120px' }}
                                {...register("metaTags")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.metaTags?.message}
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </Col>



            </Row>
        </>
    );
};






const pagesData = {
    'about-dreams': {
        title: 'About Dreams',
    },
    'about-prf': {
        title: 'About PRF',
    },
    'about-dreams-home': {
        title: 'About Dreams Home',
    },
    'organogram': {
        title: 'Organogram',
    },
    'our-initiatives': {
        title: 'Our Initiatives',
    },
    'our-cities': {
        title: 'Our Cities',
    },
    'our-vision': {
        title: 'Our Vision',
    },
    'our-mission': {
        title: 'Our Mission',
    },
    'goals': {
        title: 'Goals',
    },
    'objectives': {
        title: 'Objectives',
    },
    'downloads': {
        title: 'Downloads',
    },
    'leadership': {
        title: 'Leadership',
    },
    'cteam': {
        title: 'CTeam',
    },
    'procurement': {
        title: 'Procurement',
    },
    'events': {
        title: 'News Events',
    },
    'jobs': {
        title: 'Jobs',
    },
}




const DynamicPage = ({ defaulPageName }) => {
    const methods = useForm({
        resolver: yupResolver(schema),
        defaultValues: {},
    });
    const { handleSubmit, reset } = methods;

    const { pageNamee } = useParams();
    const pageName = pageNamee || defaulPageName;


    const onSubmit = (data) => {
        console.log(data);
        setLoading(true)
        const finalData = {
            id: parseInt(data.pID),
            heading: data.pTitle,
            backgroundImage: data.fFile,
            pageName: data.pName,
            pageContent: data.fDescription,
            pageUrl: data.url,
            metaInfo: data.metaDescription,
            footer: data.metaTags,
            sortOrder: 0,
            status: true,
            pageType: 'DYNAMIC'
        }

        if (finalData.id) {
            PostPage(finalData).then(res => {

                toast.success('Page Updates Successfully', {
                    theme: "colored",
                });
                setLoading(false)

            }).catch(err => {

                toast.error('Page Update Failed', {
                    theme: "colored",
                });
                setLoading(false)
                console.log(err, 'PostDownloadsError')

            });

        }


    };

    const [loading, setLoading] = useState(false);


    const [editData, setEditData] = useState({});



    const FORMProvider = ({ dpn }) => {


        return (
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(onSubmit)}>


                    <Row className="g-3">
                        {/* maxHeight: '60vh', minHeight: '60vh', overflow: 'auto' */}
                        <Col lg={12} style={dpn ? {} : {}}>
                            <SettingsForm setLoading={setLoading} />
                        </Col>

                        <Col xs={12}>
                            <Row className="flex-between-center mt-3">
                                <Col md>
                                    {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                                </Col>
                                <Col xs="auto">
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        Save Page {loading && '...'}
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                    </Row>



                </Form>
            </FormProvider>
        )
    }



    const fetchPage = () => {
        setLoading(true)
        GetPageByName(pagesData[pageName]?.title).then(res => {


            const tPage = res?.data?.data;

            if (tPage) {
                reset({
                    pTitle: tPage?.heading,
                    fFile: tPage?.backgroundImage,
                    fDescription: tPage?.pageContent,
                    metaDescription: tPage?.metaInfo,
                    metaTags: tPage?.footer,
                    url: tPage?.pageUrl,
                    pName: tPage?.pageName,
                    pID: tPage?.id,
                })
            }
            else {
                reset(initialForm)
            }
            setLoading(false)

        }).catch(err => {
            setLoading(false)
            console.log(err, 'GetSettingsAPIError')
        })

    };

    useEffect(() => {
        fetchPage();

    }, [pageName]);


    if (defaulPageName) {
        return (
            <>
                <MEILoader showLoader={loading} />
                <FORMProvider dpn={defaulPageName} />
            </>
        )
    }



    return (
        <>
            <div className="py-2 pt-0">
                <BreadCrumb />
            </div>


            <MEILoader showLoader={loading} />
            <Card className="mb-0">
                <Card.Header>
                    <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">{pagesData[pageName]?.title.replaceAll('Dreams', 'DREAMS-I')}</h5>
                </Card.Header>
                <Card.Body className="pt-0 p-3" >

                    <FORMProvider />

                </Card.Body>
            </Card>


        </>
    );
};

export default DynamicPage;
